import React from "react";
import { createReceiptPrintElement } from "./receiptPrintTemplate.mjs";
import "./ReceiptDetails.css";

export default function ReceiptPrint(props) {
  return createReceiptPrintElement(React, props);
}
